// @ts-nocheck
import dom from "../../dom2.js";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const dontTreeShakeDom = dom;
import classnames from "classnames";
import tippy from "../tippy-control.js";
import {Integration} from "../../../index.js";

// Based on pn-www/src/static/js/app/components/project/outline/index/annotation-menu.js

/**
 * @param {Object}   props
 * @return {HTMLElement}
 */
const IconButton = props => {
	const {
		// addTippyAttr = false, // Don't init the tooltip here, but do add data-tippy-content
		// children, // Don't let it show up on the <button>
		className,
		disabled,
		icon,
		showToolTip = true, // init the tooltip in the IconButton component
		tippyOptions = {},
		tooltipText = "",
		type = "button",
		...rest
	} = props;

	const isPqIntegration = Integration.isIntegration() && Integration.name === "proquest";

	const button = <button
		className={classnames("aa-btn-ext-icon", className, {
			"__pq-int__": isPqIntegration
		})}
		type={type}
		aria-label={tooltipText}
		data-tippy-content={tooltipText}
		{...disabled && {disabled: "disabled"}}
		{...rest}
	>
		<i className={icon} />
	</button>;

	if (tooltipText !== "" && showToolTip)
		tippy(button, tippyOptions);

	return button;
};

export default IconButton;
